/** Shape of the check indicator beside each panel. When not set, each style mode uses its own default. */
export enum SelectionPanelCheckShape {
    /** Round indicator (the Enhanced default). */
    Circle = 'circle',
    /** Square checkbox (the Condensed default). */
    Square = 'square',
}
